import styled from "styled-components"
import {primary} from "@uprise/colors"

export const ColumnContainer = styled.label`
	display: flex;
	align-items: center;
	justify-content: space-evenly;
`

export const TableFirstColumnText = styled.span`
	/* padding: 6px 0 6px 12px; */
	text-align: left;
	width: 100px;
	/* margin: 0; */
	font-family: "Proxima Nova";
	font-size: 15px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.33;
	cursor: pointer;
	letter-spacing: normal;
	color: #7d60ff;
`

export const SearchInput = styled.input`
	width: 250px;
	height: 32px;
	padding: 0 20px 0 32px;
	align-self: center;
	margin-right: 24px;
	border: 0;
	border-bottom: 1px solid ${primary.purple};
	&:focus {
		outline: none;
	}
`
